// For Sup China or Custom fulfillment

import { useMutation, useQuery } from "@apollo/react-hooks";
import { ChoiceList, Modal } from "@shopify/polaris";
import React, { useCallback, useEffect, useRef, useState } from "react";

import { UPDATE_PRODUCT_BASE_SHIPPING_OPTION_FOR_ORDER } from "../../../graphql/mutations";
import { GET_PRODUCT_BASE_SHIPPING_OPTION_BY_ORDER } from "../../../graphql/queries";
import { arrInvalid, handleError } from "../../../helper";
import { useToastContext } from "../../shared/ToastContext";

export function UpdateProductBaseShippingOption({
    value,
    orderIDs,
    thirdPartyFF,
    open,
    onClose,
    refetch,
    isPrintway,
    isPrintify,
    isPGPrints,
    isPrintBelle,
    isBulkAction,
}) {
    // Props
    const { id, fulfillmentServiceShippingOption } = value || {};

    const [options, setOptions] = useState([]);
    const [selected, setSelected] = useState([null]);

    // Context
    const { toggleToast, setNotify } = useToastContext();
    const refetchTimeoutRef = useRef(null);

    const { data } = useQuery(GET_PRODUCT_BASE_SHIPPING_OPTION_BY_ORDER, {
        variables: {
            id,
        },
        skip: !id
    });

    // Mutation
    const [update, { loading }] = useMutation(
        UPDATE_PRODUCT_BASE_SHIPPING_OPTION_FOR_ORDER,
        {
            onCompleted: () => {
                setNotify({
                    msg: "Update shipping option success.",
                    err: false,
                });
                refetchTimeoutRef.current = setTimeout(() => {
                    refetch && refetch();
                }, 1500);

                onClose && onClose(false);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    React.useEffect(() => {
        if (fulfillmentServiceShippingOption == null) return;
        setSelected([fulfillmentServiceShippingOption]);
    }, [fulfillmentServiceShippingOption]);

    useEffect(() => {
        const nodes = (data?.getProductBaseShippingOptionByOrder || [])
            .map((item) =>
                item?.name ? { value: item.name, label: item.name } : null,
            )
            .filter(Boolean);
        setOptions(nodes);
    }, [data]);

    useEffect(
        () => () => {
            refetchTimeoutRef.current &&
                clearTimeout(refetchTimeoutRef.current);
        },
        [],
    );

    // Actions
    const [newShippingOption] = selected || [];
    const handleSubmit = useCallback(() => {
        if (arrInvalid(orderIDs) || !newShippingOption) {
            return;
        }

        toggleToast && toggleToast();
        setNotify({ msg: null, err: false });
        update({
            variables: {
                ids: orderIDs,
                shippingOption: newShippingOption,
            },
        });
    }, [newShippingOption, orderIDs, update, toggleToast, setNotify]);

    return (
        <Modal
            title="Update shipping option"
            open={open}
            onClose={onClose}
            sectioned
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
        >
            <ChoiceList
                choices={options}
                selected={selected}
                title="Shipping Options"
                onChange={(selected) => setSelected(selected)}
            />
        </Modal>
    );
}
